import {
  call, put, select, takeEvery, takeLatest,
} from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import selectors from '@/selectors';
import { wildcardFilter } from '@/utils/resultsHelper';
import service from '../service';
import {
  showTaskTemplateTaskError,
  showTaskTemplateForTask,
  showTaskTemplates,
  showTaskTemplatesError,
} from '../actions';
import actions from '../constants';

export function* taskTemplates(action) {
  const items = yield select(selectors.taskTemplates);
  const { filter, pageSize, currentPage } = items[action.category];
  const page = action.page || currentPage;
  const size = action.pageSize || pageSize;
  const { response, error } = yield call(callAdapter, service.taskTemplates(wildcardFilter(filter), page, size));

  if (error) {
    yield put(showTaskTemplatesError(action.category, error));
  } else {
    yield put(showTaskTemplates(
      action.category,
      action.append,
      size,
      response.items,
      response.paging.total,
      response.paging.pages,
      response.paging.page,
    ));
  }
}

export function* taskTemplateForTask({ category, code, taskCode }) {
  const { response, error } = yield call(callAdapter, service.taskTemplate(taskCode));
  if (error) {
    yield put(showTaskTemplateTaskError(category, code, taskCode, error));
  } else {
    yield put(showTaskTemplateForTask(category, code, taskCode, response));
  }
}

export default function* taskTemplatesApi() {
  yield takeEvery([actions.FETCH_TASK_TEMPLATES, actions.REFRESH_TASK_TEMPLATES], taskTemplates);
  yield takeLatest(actions.FETCH_TASK_TEMPLATE_FOR_TASK, taskTemplateForTask);
}
